export const getValueByPath = <T>(
  obj: Record<string, any>,
  path: string | string[]
): T | undefined => {
  const keys = Array.isArray(path) ? path : path.split('.');

  return keys.reduce((acc: any, key: string) => {
    if (acc && typeof acc === 'object' && key in acc) {
      return acc[key];
    } else {
      return undefined;
    }
  }, obj);
};
